module.exports = __webpack_public_path__ + "static/media/discover.7250ebd6.svg";